import { createApp } from 'vue'
import App from './App.vue'
import 'lib-flexible'
import vConsole from 'vconsole'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import { ImagePreview } from 'vant'

const isEnvProduction = process.env.NODE_ENV === 'production'
const environment = isEnvProduction ? 'production' : 'test'

if (!isEnvProduction) {
  new vConsole()
}

const app = createApp(<App />)

if (isEnvProduction) {
  Sentry.init({
    app,
    dsn: 'https://8ceea622ed4448c4a4b5825e6e030c3f@sentry.xhey.top/2',
    release: '2.0.0',
    environment,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: ['localhost', 'h5.xhey.top', /^\//]
      })
    ],
    tracesSampleRate: 0.5
  })
}

app.use(ImagePreview)
app.mount('#app')
